// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body > div.membership-payment-class > svg */

/* .membership-payment-class {
    svg {
        margin-top: 40px;
    }
} */

.membership-payment-class > svg:first-of-type {
    margin-top: 6rem !important;
}

.membership-payment-class > button:first-of-type {
    margin-top: 5.8rem !important;
}`, "",{"version":3,"sources":["webpack://./sections/settings/subsections/MembershipPayment/payment.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;;;;GAIG;;AAEH;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["/* body > div.membership-payment-class > svg */\n\n/* .membership-payment-class {\n    svg {\n        margin-top: 40px;\n    }\n} */\n\n.membership-payment-class > svg:first-of-type {\n    margin-top: 6rem !important;\n}\n\n.membership-payment-class > button:first-of-type {\n    margin-top: 5.8rem !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
